import { ERROR_CODE as s } from "../../constants/error.js";
import { LocalStorageKey as e } from "../../constants/storage.js";
import { CustomError as l } from "../../errors/customError.js";
import { decode as a } from "jsonwebtoken";
import * as c from "ramda";
const t = () => typeof window < "u", d = (o, r) => {
  localStorage.setItem(e.AccessToken, o), localStorage.removeItem(e.FakeRefreshToken), r && localStorage.setItem(e.RefreshToken, r);
}, k = (o) => {
  localStorage.removeItem(e.AccessToken), localStorage.removeItem(e.RefreshToken);
}, h = () => t() ? localStorage.getItem(e.AccessToken) : null, S = () => t() ? localStorage.getItem(e.RefreshToken) : null, u = () => {
  const o = t() ? localStorage.getItem(e.AccessToken) : null;
  if (o)
    try {
      if (!!localStorage.getItem(e.FakeRefreshToken))
        return !0;
      const n = a(o, { complete: !0 });
      return c.pathOr(0, ["payload", "exp"], n) < (/* @__PURE__ */ new Date()).getTime() / 1e3;
    } catch {
      return console.warn("Cannot decode existing JWT"), !0;
    }
  return !1;
}, I = (o) => {
  t() && localStorage.setItem(e.Provider, o);
}, v = () => {
  t() && localStorage.removeItem(e.Provider);
}, y = () => {
  if (t())
    return localStorage.getItem(e.Provider);
}, C = (o) => {
  if (t())
    try {
      const r = a(o, { complete: !0 }), n = c.path(
        ["payload", "loginNetwork"],
        r
      );
      if (c.isNil(n))
        throw new l(
          "No login type in access token",
          s.LOGIN.CANNOT_GET_ACCOUNT_RESPONSE
        );
      localStorage.setItem(e.ChainType, n);
    } catch (r) {
      console.warn(`Error on save chain type: ${r.message}`);
    }
}, R = () => {
  t() && localStorage.removeItem(e.ChainType);
}, w = () => {
  if (t())
    return localStorage.getItem(e.ChainType);
};
export {
  u as accessTokenExpired,
  R as cleanChainType,
  v as cleanProvider,
  k as cleanTokens,
  h as getAccessToken,
  w as getChainType,
  y as getProvider,
  S as getRefreshToken,
  C as saveChainType,
  I as saveProvider,
  d as saveTokens
};
//# sourceMappingURL=index.js.map
